import './index.css';
import { useModal } from "../../contexts/modal";
import { useMessages } from "../../contexts/messages";

const ModalLg = ({ children, className }) => {
  const { isModalOpen, closeModal } = useModal();
  const { showHTMLEditor, setShowHTMLEditor } = useMessages();

  if (!isModalOpen) return null;

  const handleCloseModal = () => {
    setShowHTMLEditor(false)
    closeModal()
  }

  return (
    <div
      className="fixed inset-0 bg-gray-900/50 flex justify-center items-center z-50"
      onMouseDown={handleCloseModal}
    >
      <div
        className={`bg-white rounded-lg shadow-lg p-6  min-w-fit max-h-full relative no-scrollbar overflow-y-scroll ${className} ${showHTMLEditor ? 'w-3/4' : 'w-1/2'}`}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <button
          onClick={handleCloseModal}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 font-bold text-2xl"
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default ModalLg;
